/**
 * This place where we put out
 * Chat definitions method
 */

// API calls, SDK methods, filtering data etc and then calling the state mutation method for manipulating the state
export const actions = {
  setCurrentConcierge: 'setCurrentConcierge',
  updateCurrentConcierge: 'updateCurrentConcierge',
  updateConciergeOnlineStatus: 'updateConciergeOnlineStatus',
  initializeConciergeList: 'initializeConciergeList',
  updateConciergeList: 'updateConciergeList',
  updateConcierge: 'updateConcierge',
  updateConciergePayout: 'updateConciergePayout',
  setConciergeRewards: 'setConciergeRewards',
  setConciergeUniqueUsers: 'setconciergeUniqueUsers',
  setConciergeChats: 'setconciergeChats',
  setConciergeProfileVisits: 'setConciergeProfileVisits'
};

// only the state manipulator.
export const mutations = {
  setCurrentConcierge: 'setCurrentConcierge',
  updateCurrentConcierge: 'updateCurrentConcierge',
  updateConciergeOnlineStatus: 'updateConciergeOnlineStatus',
  setConciergeList: 'setConciergeList',
  updateConciergeList: 'updateConciergeList',
  setConciergeRewards: 'setConciergeRewards',
  updateConciergeChannel: 'updateConciergeChannel',
  setConciergeUniqueUsers: 'setconciergeUniqueUsers',
  setConciergeChats: 'setconciergeChats',
  setConciergeProfileVisits: 'setConciergeProfileVisits'
};

export default {
  actions,
  mutations
};
